import PortalAuthenticationService from "./bases/PortalAuthenticationService";

class PowerBiService extends PortalAuthenticationService{
    async ObterTokenRls(data){
        return await this.post(`PowerBi/PowerBiTokenRLS`, data)
    }
}




export default new PowerBiService();